<template>
  <md-card>
    <md-card-content>
      <time-line plain class="binnacle">
        <time-line-item
          class="binnacle-entry"
          badge-type="info"
          badge-icon="account_circle"
          color="red"
        >
          <div slot="header">
            <badge type="success">Líder</badge>
          </div>

          <div slot="content" class="time-content">
            <StaffCard v-model="leader" />
          </div>
        </time-line-item>

        <time-line-item
          class="binnacle-entry"
          badge-type="info"
          badge-icon="person"
          color="blue"
        >
          <div slot="header">
            <badge type="success">Supervisores</badge>
          </div>

          <div slot="content" class="supervisors-item time-content">
            <StaffCard
              v-for="supervisor in value.supervisors"
              :key="supervisor.id"
              :value="supervisor"
            />
            <StaffCard
              v-if="editMode"
              :editMode="editMode"
              :catalogs="catalogs"
              v-model="newSupervisor"
            />
          </div>
        </time-line-item>
      </time-line>
    </md-card-content>
  </md-card>
</template>

<script>
import TimeLine from "@/components/Timeline/TimeLine";
import TimeLineItem from "@/components/Timeline/TimeLineItem";
import Badge from "@/components/Badge";
import StaffCard from "./StaffCard";

export default {
  name: "DivisionSchema",
  components: {
    TimeLine,
    TimeLineItem,
    Badge,
    StaffCard,
  },
  props: {
    value: {
      type: Object,
      required: true,
      default: () => {},
    },
    catalogs: {
      type: Object,
      required: true,
      default: () => {},
    },
    editMode: {
      type: Boolean,
      required: true,
      default: () => false,
    },
  },
  data() {
    return {
      newSupervisor: {},
    };
  },
  computed: {
    leader() {
      return this.value && this.value.leader;
    },
  },
  watch: {
    editMode() {
      this.newSupervisor = {};
    },
  },
};
</script>

<style lang="scss" scoped>
.md-card-content {
  display: flex;
  width: 150%;
  transform: translate(10%, 0%);
}
.time-content {
  font-size: 16px;
}
.movement-info {
  font-size: 12px;
  margin: 0 !important;
}
p {
}
.binnacle {
  margin-top: 0px;
}
.binnacle-entry {
  margin-bottom: 4px;
}
.binnacle-entry > .timeline-panel {
  margin-top: 0px;
  margin-bottom: 0px;
  padding-bottom: 0px;
  padding-top: 0px;
}

.supervisors-item {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
</style>



// WEBPACK FOOTER //
// src/pages/Catalogs/Divisions/DivisionSchema.vue